import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from "../../../../model/tenant";

@Component({
  selector: 'app-tenant-overview',
  templateUrl: './tenant-overview.component.html',
  styleUrls: ['./tenant-overview.component.scss']
})
export class TenantOverviewComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  constructor() { }

  ngOnInit(): void {
  }

}
